import isMap from './isMap';

export default function ownKeys(object) {
  if (isMap(object)) {
    return Array.from(object.keys());
  }

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/ownKeys.js
// module id = ./node_modules/redux-actions/es/utils/ownKeys.js
// module chunks = 6 9 11